import { render, staticRenderFns } from "./shippingRuleDetail.vue?vue&type=template&id=e9b50854"
import script from "./shippingRuleDetail.vue?vue&type=script&lang=js"
export * from "./shippingRuleDetail.vue?vue&type=script&lang=js"
import style0 from "./shippingRuleDetail.vue?vue&type=style&index=0&id=e9b50854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports